import React, {useEffect, useState} from "react";
import {useSelector, useDispatch} from "react-redux";
import {useParams, useNavigate} from "react-router-dom";
import {
    DollarSignIcon, TrashCanIcon,
} from "../../Components/Icons";
import {
    deleteUserData,
    getAdminUserData,
    isTxnVoidable,
    redirectPayUserForAdminLookup, refundTxn
} from "../../Actions/authActions";
import Table from "./../AdminDashboard/ReactTable/ReactTableMain";
import {subDomain, amountFormatterWithZero} from "../../utils";
import sumBy from "lodash/sumBy";
import map from "lodash/map";
import CustomPopoverDelete from "../../Components/CustomPopoverDelete";
import CustomePopUp from "../../Components/customePopUp";
import {DELETE_USERDATA_INITIAL, SHOULD_RELOAD_TABLE_DATA, TRANSACTION_REFUND_CLEAR} from "../../constants";
import "./payersTable.css";
import moment from "moment";
import {withButtonLoader} from "../../helpers";
import CustomPopoverRefund from "../../Components/CustomPopoverRefund";
import {executeGet} from "../../Api";
import ReactTableServerSide from "./ReactTable/ReactTableServerSide";
import Switch from "react-switch";


const TransactionsTable = (props) => {


    const dispatch = useDispatch();
    const {homePage, subdomain, themeColor1, userAdmin} = props;


    useEffect(() => {
        if (!Object.keys(userAdmin).length && homePage === "transactions") {
            dispatch(getAdminUserData(subdomain));
        }
    }, [!userAdmin]);

    const isTransactionLoading = useSelector(
        (state) => state.auth.isTransactionLoading
    );
    const transactionData = useSelector((state) => state.auth.transactionData);
    const [filteredData, setFilteredData] = useState({});
    const [clearSearch, setClearSearch] = useState("");
    const [transactionPage, setTransactionPage] = useState("All Transactions");
    const [switchChecked, setSwitchChecked] = useState(false);

    const handleSwitchChange = () => {
        setSwitchChecked(!switchChecked);
    }

    // useEffect(() => {
    //     if (homePage === "transactions") {
    //         dispatch(getTransaction(subdomain));
    //     }
    // }, [homePage]);

    useEffect(() => {
        if (transactionData) {
            setFilteredData(transactionData);
        }
    }, [transactionData]);


    const [target, setTarget] = useState(null);
    const [transactionForRefund, setTransactionForRefund] = useState({});
    const [showPopUp, setShowPopUp] = useState(false);
    const [showSuccessPopUp, setSuccessPopUp] = useState(false);
    const [showErrorPopUp, setShowErrorPopUp] = useState(false);

    const transactionIsVoidableLoading = useSelector(
        (state) => state.auth.transactionIsVoidableLoading
    );
    const transactionIsVoidableTxnId = useSelector(
        (state) => state.auth.transactionIsVoidableTxnId
    );
    const transactionIsVoidable = useSelector(
        (state) => state.auth.transactionIsVoidable
    );
    const transactionIsVoidableSuccess = useSelector(
        (state) => state.auth.transactionIsVoidableSuccess
    );

    const transactionIdRefund = useSelector(
        (state) => state.auth.transactionIdRefund
    );

    const transactionRefundLoading = useSelector(
        (state) => state.auth.transactionRefundLoading
    );
    const transactionRefundSuccess = useSelector(
        (state) => state.auth.transactionRefundSuccess
    )

    const transactionRefundError = useSelector(
        (state) => state.auth.transactionRefundError
    )

    const transactionIsVoidableError = useSelector(
        (state) => state.auth.transactionIsVoidableError
    )

    //david fix this -- it needs to pop up a refund for only 1 row
    // useEffect(() => {
    //     if (transactionIsVoidableTxnId) {
    //         if (transactionIsVoidableSuccess && transactionIsVoidableTxnId === transaction._id) {
    //             setShowPopUp(true);
    //         }
    //     }
    // }, [transactionIsVoidableSuccess, transactionIsVoidableTxnId]);

    useEffect(() => {
        if (transactionIsVoidableTxnId && transactionIsVoidableSuccess) {
            setShowPopUp(true);
        }
    }, [transactionIsVoidableSuccess, transactionIsVoidableTxnId]);

    // useEffect(() => {
    //     if (transactionIdRefund === transaction._id && transactionRefundSuccess) {
    //         setShowPopUp(false);
    //         setSuccessPopUp(true);
    //     }
    // }, [transactionIdRefund, transactionRefundSuccess]);


    useEffect(() => {
        if (transactionRefundSuccess) {
            setShowPopUp(false);
            setSuccessPopUp(true);
        }
    }, [transactionIdRefund, transactionRefundSuccess]);


    //
    // useEffect(() => {
    //     if (transactionIdRefund === transaction._id && transactionRefundError) {
    //         setShowPopUp(false);
    //         setShowErrorPopUp(true);
    //     }
    // }, [transactionIdRefund, transactionRefundError]);


    useEffect(() => {
        if (transactionRefundError) {
            setShowPopUp(false);
            setShowErrorPopUp(true);
        }
    }, [transactionIdRefund, transactionRefundError]);

    //
    // useEffect(() => {
    //     if (transactionIsVoidableTxnId === transaction._id && transactionIsVoidableError) {
    //         setShowPopUp(false);
    //         setShowErrorPopUp(true);
    //     }
    // }, [transactionIsVoidableTxnId, transactionIsVoidableError]);

    useEffect(() => {
        if (transactionIsVoidableError) {
            setShowPopUp(false);
            setShowErrorPopUp(true);
        }
    }, [transactionIsVoidableTxnId, transactionIsVoidableError]);


    const startRefund = (event, transactionId, selectedTxn) => {
        setTarget(event.target);
        dispatch(isTxnVoidable(transactionId));
        setTransactionForRefund(selectedTxn);
    }

    const doRefund = (transactionId, patients) => {
        dispatch(refundTxn(transactionId, patients));
    }

    const handleClosePopUp = () => {
        dispatch({type: TRANSACTION_REFUND_CLEAR});
        setShowPopUp(false);
        setTransactionForRefund({});
    };

    const handleSuccessClosePopUp = () => {
        dispatch({type: SHOULD_RELOAD_TABLE_DATA});
        dispatch({type: TRANSACTION_REFUND_CLEAR});
        setSuccessPopUp(false);
        setTransactionForRefund({});
    }

    const handleErrorClosePopUp = () => {
        dispatch({type: TRANSACTION_REFUND_CLEAR});
        setShowErrorPopUp(false);
        setTransactionForRefund({});
    }

    const DisplayRefund = (transaction) => {
        const txntxn = transaction && transaction.transaction;
        if (txntxn && txntxn.patientPayerRefundAmts && txntxn.patientPayerRefundAmts.length && txntxn.refundedDate) {
            let totalRefunded = 0;
            for (const refund of txntxn.patientPayerRefundAmts) {
                totalRefunded += parseFloat(refund.amountRefunded);
            }
            return <>
                ${amountFormatterWithZero(totalRefunded)}<br/>
                <i>{moment(txntxn && txntxn.refundedDate).format("MM/DD/YYYY")}<br/>
                    {moment(txntxn && txntxn.refundedDate).format("hh:mm a")}</i>
            </>;
        } else {
            return <></>
        }
    }


    const displayPatientPayers = (row, property) => {

        return (row.patientPayer.map((v, i) => {
            let displayText = "";
            if (property === "patientName") {
                displayText = `${v.patientFirst ? v.patientFirst : ''} ${v.patientMiddle ? v.patientMiddle : ''} ${v.patientLast ? v.patientLast : ''}`;
            } else if (property === "amountPaid") {
                displayText = `$${amountFormatterWithZero(v[property])}`;
            } else {
                displayText = v[property];
            }
            return (<table
                key={i}
                style={{
                    tableLayout: "fixed", width: "100%",
                }}
            >
                <tbody>

                <tr style={{width: "100%"}}>
                    <td style={{width: "100%"}}>{displayText}</td>
                </tr>
                </tbody>
            </table>)
        }))
    };


    // Helper to detect if a transaction is from Converge (has ssl_ fields) or NMI
    const isConvergeTransaction = (txnRecord) => {
        return txnRecord.transactionsData?.ssl_card_type || txnRecord.transactionsData?.ssl_amount;
    }

    // Universal helper functions that work with both Converge and NMI
    const getLastFour = (txnRecord) => {
        if (isConvergeTransaction(txnRecord)) {
            // Converge: use ssl_ fields
            if (txnRecord.transactionsData &&
                txnRecord.transactionsData.ssl_card_number &&
                txnRecord.transactionsData.ssl_card_number > "") {
                return txnRecord.transactionsData.ssl_card_number.slice(-4);
            } else if (txnRecord.transactionsData &&
                txnRecord.transactionsData.ssl_bank_account_number &&
                txnRecord.transactionsData.ssl_bank_account_number > "") {
                return txnRecord.transactionsData.ssl_bank_account_number.slice(-4);
            }
        } else {
            // NMI: use root-level fields
            return txnRecord.lastFourDigits || "";
        }
        return "";
    }

    const standardizeNmiCardType = (paymentMethod) => {
        if (!paymentMethod) return "";

        const normalized = paymentMethod.toLowerCase().trim();

        if (normalized.includes("mastercard") || normalized === "mc") {
            return "MC";
        } else if (normalized.includes("discover") || normalized === "disc") {
            return "DISC";
        } else if (normalized.includes("american express") || normalized.includes("amex")) {
            return "AMEX";
        } else if (normalized.includes("visa")) {
            return "VISA";
        }

        // If not one of the standard 4, return original
        return paymentMethod;
    }

    const getPaymentMethod = (txnRecord) => {
        if (isConvergeTransaction(txnRecord)) {
            // Converge: use ssl_ fields
            if (txnRecord.transactionsData &&
                txnRecord.transactionsData.ssl_card_type &&
                txnRecord.transactionsData.ssl_card_type > "") {
                if (txnRecord.transactionsData.ssl_card_type === "ELECTRONICCHECK") {
                    return "eCheck"
                } else if (txnRecord.transactionsData.ssl_card_type === "CREDITCARD") {
                    return txnRecord?.transactionsData?.ssl_card_short_description;
                }
            }
        } else {
            // NMI: use root-level fields and standardize card types
            const paymentMethod = txnRecord.paymentMethodDescription || "";
            return standardizeNmiCardType(paymentMethod);
        }
        return "";
    }

    const print = (transaction) => {
        const isConverge = isConvergeTransaction(transaction);

        const docDefinition = {
            content: [
                {text: `Receipt for ${userAdmin.officeName}`, style: 'header'},
                ' ',
                ...transaction.patientPayer.map(o => {
                    return {
                        columns: [
                            {text: 'Patient:', width: '20%'},
                            {text: o.patientFirst + ' ' + o.patientLast + '(#' + o.patientNumber + ')', width: '80%'}
                        ],
                        style: 'column'
                    }
                }),
                {
                    columns: [
                        {text: 'Date:', width: '20%'},
                        {text: moment(transaction.createdAt).format('MM/DD/YYYY hh:mm a'), width: '80%'}
                    ],
                    style: 'column'
                },
                {
                    columns: [
                        {
                            text: (isConverge ? transaction.transactionsData.ssl_card_short_description : transaction.paymentMethodDescription) + ':',
                            width: '20%'
                        },
                        {
                            text: "xxxx" + (isConverge ? transaction.transactionsData.ssl_card_number.slice(-4) : transaction.lastFourDigits),
                            width: '80%'
                        }
                    ],
                    style: 'column'
                },
                {
                    columns: [
                        {text: 'Amount Paid:', width: '20%'},
                        {text: '$' + transaction.total, width: '80%'}
                    ],
                    style: 'column'
                },
                ' ',
                {text: 'Transaction ID:', style: 'subheader'},
                transaction.transactionId
            ],
            styles: {
                header: {
                    fontSize: 20,
                    bold: true,
                    alignment: 'center',
                    margin: [0, 0, 0, 10]
                },
                subheader: {
                    fontSize: 14,
                    bold: true,
                    margin: [0, 10, 0, 5]
                },
                column: {
                    fontSize: 14,
                    margin: [0, 5, 0, 0]
                }
            }
        };

        pdfMake.createPdf(docDefinition).print();
    }

    // Universal columns definition that works with both Converge and NMI transactions
    const columns = React.useMemo(() => [
        {
            id: "payerLast",
            header: "Payer Last",
            accessorFn: (row) => {
                return `${row && row.payerLast || row.transactionsData?.ssl_last_name || ""}`
            },
        },
        {
            id: "payerFirst",
            header: "Payer First",
            accessorFn: (row) => {
                return `${row && row.payerFirst || row.transactionsData?.ssl_first_name || ""} ${row && row.payerMiddle || ''}`
            },
        },
        {
            id: "payerEmail",
            header: "Payer Email",
            accessorFn: (row) => row && row.payerEmail && row.payerEmail.startsWith("*fake*") ? "" : (row?.payerEmail || ""),
        },
        {
            id: "payerCell",
            header: "Payer Cell",
            accessorFn: (row) => row && row.payerCell && row.payerCell.startsWith("*fake*") ? "" : (row?.payerCell || ""),
        },
        {
            id: "totalAmount",
            header: "Total Amount",
            enableColumnFilter: true,
            accessorFn: (row) => {
                // Converge uses ssl_amount, NMI uses total
                const amount = isConvergeTransaction(row)
                    ? row.transactionsData?.ssl_amount
                    : row.total;
                return `$${amountFormatterWithZero(amount)}`;
            },
        },
        {
            id: "date",
            header: "Date",
            enableColumnFilter: true,
            accessorFn: (row) => row && row.createdAt && moment(row.createdAt).format("MM/DD/YYYY"),
            cell: (props) => moment(props.row.original && props.row.original.createdAt).format("MM/DD/YYYY hh:mm a"),
        },
        {
            id: "lastFourDigits",
            header: "Payment Method",
            enableColumnFilter: true,
            accessorFn: (row) => {
                const txnId = isConvergeTransaction(row)
                    ? row.transactionsData?.ssl_txn_id
                    : row.transactionId;
                return `${getLastFour(row)} __ ${txnId || ""}`;
            },
            cell: (props) => {
                const txnId = isConvergeTransaction(props.row.original)
                    ? props.row.original.transactionsData?.ssl_txn_id
                    : props.row.original.transactionId;
                return <div>
                    <span title={txnId}>
                        {getPaymentMethod(props.row.original)} <br/>{getLastFour(props.row.original)}
                    </span>
                </div>;
            },
        },
        {
            id: "patientNumber",
            header: "Patient Number",
            disableSortBy: true,
            accessorFn: (row) => row.patientPayer.map((ptPayer) => ptPayer.patientNumber).join("_"),
            cell: (props) => displayPatientPayers(props.row.original, "patientNumber"),
        },
        {
            id: "patientFirst",
            header: "Patient First",
            disableSortBy: true,
            accessorFn: (row) => row.patientPayer.map((ptPayer) => `${ptPayer.patientFirst} ${ptPayer.patientMiddle}`).join("_"),
            cell: (props) => displayPatientPayers(props.row.original, "patientFirst"),
        },
        {
            id: "patientLast",
            header: "Patient Last",
            disableSortBy: true,
            accessorFn: (row) => row.patientPayer.map((ptPayer) => `${ptPayer.patientLast}`).join("_"),
            cell: (props) => displayPatientPayers(props.row.original, "patientLast"),
        },
        {
            id: "patientAmount",
            header: "Patient Amount",
            enableColumnFilter: false,
            disableSortBy: true,
            accessorFn: (row) => row.patientPayer.map((ptPayer) => ptPayer.amountPaid).join("_"),
            cell: (props) => displayPatientPayers(props.row.original, "amountPaid"),
        },
        {
            id: "Refund",
            header: "Refund",
            enableColumnFilter: false,
            disableSortBy: true,
            accessorFn: row => row._id,
            cell: (props, tableProps) => {
                if (!props.row.original.isRefunded) {
                    return (<>
                            <button
                                style={{
                                    width: "80%",
                                    height: "50%"
                                }}
                                className="sos-custom-btn  sos-custom-btn-css"
                                onClick={(event) => startRefund(event, props.row.original._id, props.row.original)}
                            >{withButtonLoader(
                                "Refund",
                                transactionIsVoidableTxnId === props.row.original._id && transactionIsVoidableLoading,
                                themeColor1)}
                            </button>
                        </>
                    )
                } else {
                    return (props.row.original &&
                        <DisplayRefund transaction={props.row.original}/> || "");
                }
            }
        },
        {
            id: "Print",
            header: "Print",
            enableColumnFilter: false,
            disableSortBy: true,
            accessorFn: row => row._id,
            cell: (props) => <button
                className="sos-custom-btn  sos-custom-btn-css"
                onClick={(event) => {
                    print(props.row.original);
                }}
            >Print
            </button>,
        }
    ], [transactionData]);

    const fetchTransactions = async ({currentPage, limit, sortBy, sortDirection, searchTerm, searchBy}) => {
        try {
            const buildQuery = {
                subdomain,
                page: currentPage,
                limit,
                searchTerm,
                searchBy,
                sortBy,
                sortDirection,
            };
            const url = `transaction/allTransactions?${new URLSearchParams(buildQuery).toString()}`;
            const result = await executeGet(url, {})
                .then((res) => {
                    const {data} = res || {};
                    return data;
                });
            return {
                data: result.transactions,
                total: result.totalCount,
                totalPages: result.totalPages,
                currentPage: result.page,
                pageSize: result.pageSize,
            };
        } catch (error) {
            console.error("Error fetching data:", error);
            return {data: [], total: 0};
        }
    };


    const colWidths = ["11%", "18%", "9%", "8%", "9%", "8%", "8%", "12%", "8%", "12%", "8%"];

    return (<>
        <div className=" container-fluid">

            {userAdmin && userAdmin.displayReconcileMode &&
                <label
                style={{
                    display: "flex", alignItems: "center", gap: "8px", justifyContent: "end", paddingBottom: "1em"
                }}
            >
                <span>Reconciliation mode</span>
                <Switch
                    onChange={handleSwitchChange}
                    checked={switchChecked}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    // offHandleColor={false}
                    // onHandleColor={false}
                    onColor="#6e86c4"
                    // offColor={false}
                    // height={100}
                    // width={100}
                />
            </label>}

            {/*{transactionData && <Table*/}
            {/*    columns={columns}*/}
            {/*    data={transactionData}*/}
            {/*    colWidths={["11%", "18%", "9%", "8%", "9%", "8%", "8%", "12%", "8%", "12%", "8%"]}*/}
            {/*    noDataMessage={"No data"}*/}
            {/*/>}*/}

            {<ReactTableServerSide
                fetchData={fetchTransactions}
                columns={columns}
                colWidths={colWidths}
                // searchPlaceholder="Name, email, cell, amount paid (25.00), date (MM/DD/YYYY), last 4 on card (1234)"
                // searchPlaceholder="Name, email, cell, amount paid (25.00), date (MM/DD/YYYY)"
                // initialSortState={{sortBy: "payerLast", desc: false}}
                initialSortState={{}}
            />}
            {(
                <CustomPopoverRefund
                    title={"Refund"}
                    show={showPopUp}
                    isLoading={transactionRefundLoading}
                    isVoidable={transactionIsVoidable === true}
                    doRefund={doRefund}
                    close={handleClosePopUp}
                    setShowPopUp={setShowPopUp}
                    transaction={transactionForRefund}
                    themeColor1={themeColor1}
                />)}
            {showSuccessPopUp && (<CustomePopUp
                message={"Refund successful"}
                openModal={showSuccessPopUp}
                onCloseModal={handleSuccessClosePopUp}
            />)}

            {showErrorPopUp ? (<CustomePopUp
                message={"Error when refunding the transaction"}
                openModal={showErrorPopUp}
                onCloseModal={handleErrorClosePopUp}
            />) : ""}
        </div>
    </>);
};
export default TransactionsTable;
